import "../../../css/bootstrap5.css";
const CheckBox = (props) => {
  return (
    <div className={`form-check m-${props.margin || 0}`}>
      <input
        className="form-check-input"
        type="checkbox"
        id={props.id || "flexCheckDefault"}
        checked={props.checked}
        onChange={props.onChange}
      />
      <label
        className={`form-check-label text-${props.textcolor || "dark"}`}
        htmlFor={props.id || "flexCheckDefault"}
      >
        {props.text}
      </label>
    </div>
  );
};

export default CheckBox;
// <CheckBox margin="3" textcolor="black" text="select"/>
